import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import '../../../../../assets/scss/user.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { upSert } from 'services/bs-sector-measurable/measurableDataService';
import {
  buildTargetTextDisplay,
} from 'helpers/kpiHelper';
import { inputPopulateType } from 'data/TempData';
import classNames from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { defaultFormatTime } from 'helpers/kpiHelper';

MesuarableTdItem.propTypes = {
  data: PropTypes.object,
  item: PropTypes.object,
  col: PropTypes.string,
  value: PropTypes.string,
  callback: PropTypes.func,
  noOfCol: PropTypes.number,
  sheduleTypeId: PropTypes.number,
  compareNoOfCol: PropTypes.number
};

export function MesuarableTdItem({
  data,
  item,
  col,
  value,
  callback,
  noOfCol,
  compareNoOfCol,
  sheduleTypeId
}) {
  const [idCellEditing, setIdCellEditing] = useState('');
  const [inputValue, setInputValue] = useState(0);
  const inputRef = useRef(null);
  const ManualEnterText = 'Manual Enter';
  const FormulaText = 'Formula';
  const [numberDisplay, setNumberDisplay] = useState('TBC');
  const [objDataColor, setObjDataColor] = useState({});
  const [classColor, setClassColor] = useState('');

  useEffect(() => {
    if (idCellEditing === `${col} ${item.id}` && inputRef.current) {
      inputRef.current.focus();
    }
  }, [idCellEditing, col, item.id]);
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    let calNumber = value;
    if (
      inputPopulateType.find(x => x.value === item.inputMethod)?.label ===
      FormulaText
    ) {
      calNumber = applyFormula(data, item);
    }
    setNumberDisplay(calNumber);
    setObjDataColor({ date: new Date(col), value: calNumber });
  }, [data, item.inputMethod, col, value, sheduleTypeId]);

  useEffect(() => {
    setClassColor(
      checkColor(
        item.variationPercentage,
        objDataColor,
        item.currentMonthTarget,
        item.previousMonthTarget,
        item.compareType
      )
    );
  }, [objDataColor]);

  const handleClick = () => {
    console.log(item, col);
    const inputMethod = inputPopulateType.find(
      x => x.value == item.inputMethod
    );
    if (inputMethod?.label == ManualEnterText) {
      setIdCellEditing(`${col} ${item.id}`);
    }
  };

  const handleOnBlur = () => {
    setIdCellEditing('');
    if (inputValue != value && inputValue != '') {
      upSert(item.id, col, inputValue, sheduleTypeId).then(() => {
        callback();
      });
    }
  };
  const getValueFromDate = data => {
    console.log(data, col);
    return data.map(item => {
      const existed = item.dateData.find(
        x => dayjs(x.date).format(defaultFormatTime) == col
      );
      return {
        id: item.id,
        value: existed?.value ?? 0,
        inputMethod: item.inputMethod,
        formula: item.formula
      };
    });
  };

  const checkColor = (
    variationPercentage,
    data,
    currentMonthTarget,
    previousMonthTarget,
    compareType
  ) => {
    if (
      !data ||
      !data.date ||
      !data.value ||
      data.value == 0 ||
      data.value == 'NaN'
    )
      return '';

    let dateStr = dayjs(data?.date).format('YYYY-MM');
    let compareMonthTarget =
      dateStr == dayjs(currentMonthTarget?.date).format('YYYY-MM')
        ? currentMonthTarget
        : previousMonthTarget;

    return getClassColor(
      data,
      compareMonthTarget,
      variationPercentage,
      compareType
    );
  };
  const getClassColor = (
    data,
    compareMonthTarget,
    variationPercentage,
    compareType
  ) => {
    const dataDebug = 1;
    if (data.value == dataDebug) {
      console.log(data, compareMonthTarget, variationPercentage, compareType);
    }
    const value = parseFloat((data?.value || '').replace(/,/g, ''), 10) || 0;
    const target =
      parseFloat((compareMonthTarget?.target || '').replace(/,/g, ''), 10) || 0;

    if (!variationPercentage || variationPercentage == 0) {
      if (value == target) {
        return 'kpiWarning';
      }
      if (compareType === 0) {
        return value > target ? 'kpiSafe' : 'kpiDanger';
      } else {
        return value > target ? 'kpiDanger' : 'kpiSafe';
      }
    }
    if (data.value == dataDebug) {
      console.log(target);
    }
    if (target === 0) {
      if (value === 0) {
        return 'kpiSafe';
      }
      return 'kpiDanger';
    }

    let lowerBound = target * (1 - variationPercentage / 100);
    if (data.value == dataDebug) {
      console.log(lowerBound, value);
    }

    if (compareType === 0) {
      if (value > target) {
        return 'kpiSafe';
      } else if (value >= lowerBound && value <= target) {
        return 'kpiWarning';
      } else {
        return 'kpiDanger';
      }
    } else if (compareType === 1) {
      if (value < lowerBound) {
        return 'kpiSafe';
      } else if (value >= lowerBound && value <= target) {
        return 'kpiWarning';
      } else {
        return 'kpiDanger';
      }
    }

    return '';
  };

  const applyFormula = (data, currentItem, visited = new Set()) => {
    const values = getValueFromDate(data);
    if (!values || values.length === 0) return;

    const formula = JSON.parse(currentItem.formula)?.formulaWithIds;
    if (!formula) {
      return;
    }
    const formulaWithValues = formula
      .split(' ')
      .map(idOrOperator => {
        if (idOrOperator.startsWith('key')) {
          const id = parseInt(idOrOperator.replace('key', ''), 10);
          const valueObj = values.find(item => item.id === id);
          if (visited.has(id)) {
            console.warn(`Detected circular reference for id: ${id}`);
            return idOrOperator;
          }

          if (valueObj && valueObj.inputMethod === 3) {
            visited.add(id);
            const valueForFormula = applyFormula(data, valueObj, visited);
            visited.delete(id);
            return valueForFormula !== undefined
              ? valueForFormula
              : idOrOperator;
          }

          return valueObj ? valueObj.value : idOrOperator;
        }
        return idOrOperator;
      })
      .join(' ');
    console.log('xxx', formulaWithValues, values);
    const result = evaluateFormula(formulaWithValues);
    return result;
  };

  const evaluateFormula = formula => {
    try {
      const cleanedFormula = formula.replace(/,/g, '');
      return eval(cleanedFormula).toFixed(2);
    } catch (error) {
      console.error('Lỗi khi tính toán công thức:', error.message);
      return null;
    }
  };

  const buildDisplayText = () => {
    const data =
      inputPopulateType.find(x => x.value === item.inputMethod)?.label ===
      FormulaText
        ? numberDisplay
        : value;
    return buildTargetTextDisplay(
      item.targetTypeValue,
      data,
      item.targetType,
      item.numOfDecimal
    );
  };

  return (
    <td
      className={classNames('text-center p-1', classColor)}
      hidden={compareNoOfCol < noOfCol}
    >
      <div onClick={handleClick}>
        {`${col} ${item.id}` === idCellEditing ? (
          <Form.Control
            ref={inputRef}
            type="number"
            name="keyword"
            placeholder=""
            onChange={e => setInputValue(e.target.value)}
            value={inputValue}
            onBlur={handleOnBlur}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                handleOnBlur();
              }
            }}
          />
        ) : (
          buildDisplayText()
        )}
      </div>
    </td>
  );
}
